/**
 * O cálculo por trás da barra de prazo, fora do componente.
 *
 * Arquivo próprio porque é função pura e testável sozinha — e porque módulo que exporta componente
 * e função ao mesmo tempo quebra a recarga rápida do Vite, que passa a recarregar a página inteira
 * a cada edição.
 */

/**
 * Que fração do prazo já correu, entre a abertura e o prazo de solução.
 *
 * Chamado fechado congela no instante do fechamento — é o consumo final, e é o que interessa
 * depois. Chamado aberto mede até agora.
 *
 * Devolve `null` quando não há prazo ou quando as datas não formam um intervalo válido (prazo
 * anterior à abertura acontece em dado importado com fuso trocado). Barra que divide por zero vira
 * `Infinity` e pinta de vermelho uma linha em que nada estourou.
 *
 * **Tempo corrido, não horas úteis.** É o que o e-Niterói desenha na tela dele, e por isso a barra
 * bate com o que o atendente vê. A medida que vale no contrato é outra: horas úteis, descontado o
 * tempo em "Pendente" (ANEXO IV p.90, definições 7 e 8; nota 4a, p.161-162).
 *
 * @param abertoEm instante de abertura
 * @param prazoSla instante do prazo de solução
 * @param fechadoEm instante de fechamento, quando houver
 * @returns a porcentagem consumida, ou `null` quando não há o que medir
 */
export function percentualConsumido(abertoEm: string, prazoSla: string | null, fechadoEm: string | null): number | null {
  if (!prazoSla) {
    return null
  }
  const abertura = Date.parse(abertoEm)
  const prazo = Date.parse(prazoSla)
  const fim = fechadoEm ? Date.parse(fechadoEm) : Date.now()
  if (!Number.isFinite(abertura) || !Number.isFinite(prazo) || !Number.isFinite(fim) || prazo <= abertura) {
    return null
  }
  return Math.max(((fim - abertura) / (prazo - abertura)) * 100, 0)
}
